export default "__VITE_ASSET__CFM4bISW__"